import googleLogo from '@/assets/icons/card/google_reviews.jpg';
import linkedinLogo from '@/assets/icons/card/linkedin.jpg';
import microsoftLogo from '@/assets/icons/card/microsoft.jpeg';
import { LineSeparator } from '@/components/LineSeparator';
import { useAuthStore } from '@/stores/useAuthStore';
import { useTranslation } from 'react-i18next';

const SocialLogin = () => {
  const { socialLogin } = useAuthStore();
  const { t } = useTranslation();

  return (
    <>
      <LineSeparator className="my-4" text={t('common:socialLogin')} />
      <div className="flex items-center justify-center">
        <button onClick={() => socialLogin('linkedin-openid')} className=" ">
          <img
            src={linkedinLogo}
            alt="LinkedIn"
            className="mr-4 size-10 object-cover"
          />
        </button>

        <button onClick={() => socialLogin('google')}>
          <img
            src={googleLogo}
            alt="Google"
            className="mr-1 size-12 object-cover"
          />
        </button>

        <button onClick={() => socialLogin('azure')}>
          <img
            src={microsoftLogo}
            alt="Microsoft"
            className="size-14 object-cover"
          />
        </button>
      </div>
    </>
  );
};

export default SocialLogin;
